import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    agentRunControlResponseSchema,
    agentRunListResponseSchema,
    agentRunPathParamsSchema,
    agentRunStartBodySchema,
    agentRunStartResponseSchema,
} from "@common/schemas/domains/agentRuns/agent-run.schema";
import {
    taskActivityListQuerySchema,
    taskActivityListResponseSchema,
    taskActivityPathParamsSchema,
} from "@common/schemas/domains/agentRuns/task-activity.schema";

const c = initContract();

const controlResponses = {
    201: agentRunControlResponseSchema,
    403: ErrorMessageSchema,
    404: ErrorMessageSchema,
    409: ErrorMessageSchema,
};

export const agentRunContract = c.router({
    start: {
        method: "POST",
        path: "/agent-runs/:workspaceId/start",
        pathParams: z.object({ workspaceId: z.string().uuid() }),
        body: agentRunStartBodySchema,
        responses: {
            201: agentRunStartResponseSchema,
            400: ErrorMessageSchema,
            403: ErrorMessageSchema,
            404: ErrorMessageSchema,
            409: ErrorMessageSchema,
        },
    },
    list: {
        method: "GET",
        path: "/agent-runs/:workspaceId",
        pathParams: z.object({ workspaceId: z.string().uuid() }),
        responses: {
            200: agentRunListResponseSchema,
            404: ErrorMessageSchema,
        },
    },
    listOrganization: {
        method: "GET",
        path: "/agent-runs/organizations/:organizationId",
        pathParams: z.object({ organizationId: z.string().uuid() }),
        responses: {
            200: agentRunListResponseSchema,
            404: ErrorMessageSchema,
        },
    },
    listTaskActivity: {
        method: "GET",
        path: "/agent-runs/:workspaceId/tasks/:taskId/activity",
        pathParams: taskActivityPathParamsSchema,
        query: taskActivityListQuerySchema,
        responses: {
            200: taskActivityListResponseSchema,
            403: ErrorMessageSchema,
            404: ErrorMessageSchema,
        },
    },
    pause: {
        method: "POST",
        path: "/agent-runs/:workspaceId/:runId/pause",
        pathParams: agentRunPathParamsSchema,
        body: z.object({}),
        responses: controlResponses,
    },
    continue: {
        method: "POST",
        path: "/agent-runs/:workspaceId/:runId/continue",
        pathParams: agentRunPathParamsSchema,
        body: z.object({}),
        responses: controlResponses,
    },
    stop: {
        method: "POST",
        path: "/agent-runs/:workspaceId/:runId/stop",
        pathParams: agentRunPathParamsSchema,
        body: z.object({}),
        responses: controlResponses,
    },
});
